import classNames, { Argument } from "classnames/dedupe";
import React, { ReactNode } from "react";
import { ValueOf } from "../../../../helpers";
import { TThemeVariant, useTheme } from "../../../Utility/ThemeProvider";

export interface IDropdownOptionProps<Option> {
  item: Option;
  labelKey: keyof Option;
  valueKey: keyof Option;
  variant?: TThemeVariant;
  selected?: boolean;
  type?: "default";
  titlePrefix?: ReactNode;
  classes?: {
    root?: Argument;
  };
  labels?: Record<string, ReactNode>;
  disabled?: boolean;
  children?: React.ReactNode;
  onSelect?: (value: ValueOf<Option>) => void;
}

export function DropdownOption<Option>({
  item,
  labelKey,
  valueKey,
  classes,
  variant,
  /** extendable options */
  labels,
  selected,
  titlePrefix,
  children,
  type,
  /** extendable options end */
  onSelect,
  disabled,
}: IDropdownOptionProps<Option>) {
  const theme = useTheme(variant);

  const handleClick = () => {
    onSelect && onSelect(item[valueKey]);
  };
  return (
    <div
      className={classNames(
        "dropdown-option h-menu-medium",
        {
          unavailable: disabled,
          "dropdown-option--dark": theme === "dark",
        },
        classes?.root,
      )}
      data-testid="SelectOption"
      onMouseDown={handleClick}
    >
      <span>{item[labelKey] as string}</span>
    </div>
  );
}
